import * as React from 'react'

import { Button, Text, Box } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const Available = ({ onSync, syncing }: { onSync: () => void; syncing: boolean }) => {
  return (
    <>
      <Text.Header2>
        {i18n.t('payroll_integrations.incidences.a3innuva.contract_deactivation.available.title')}
      </Text.Header2>
      <Box gap="s16">
        {i18n.t('payroll_integrations.incidences.a3innuva.contract_deactivation.available.message')}
      </Box>
      <Button onClick={onSync} disabled={syncing}>
        {i18n.t('payroll_integrations.incidences.a3innuva.contract_deactivation.available.submit')}
      </Button>
    </>
  )
}

export default Available
